$(document).ready(function(){
  let bottom_title = $('#bottom-title').text();
  //alert(bottom_title);
  if (bottom_title){
  	$('#main-bottom-title').text(bottom_title);
  }
  $('.cart-widget-close').click(function(){
    $('.cart-widget').removeClass('show');
    $('.cart-overlay').removeClass('show');
    $('body').removeClass('nonscroll');
  });
  
//   $('#header .top-bar .top-bar--right a.icon-search').click(function(e){
//     e.preventDefault();
//     alert('dfsfds');
//   });
  
  $(document).on("click", "#header .top-bar .top-bar--right a.icon-search", function(e){
//     e.preventDefault();
    alert('dfsfds');
  });
});